export type StatusSelectionReason = 'current' | 'unavailable' | null;

export interface StatusSelectionOption<TStatus extends string> {
  status: TStatus;
  disabled: boolean;
  reason: StatusSelectionReason;
}

export const buildStatusSelectionOptions = <TStatus extends string>(
  statuses: readonly TStatus[],
  currentStatus: string,
  allowedTransitions: readonly string[],
): StatusSelectionOption<TStatus>[] => {
  const allowed = new Set(allowedTransitions);

  return statuses.map((status) => {
    if (status === currentStatus) {
      return { status, disabled: true, reason: 'current' };
    }

    if (!allowed.has(status)) {
      return { status, disabled: true, reason: 'unavailable' };
    }

    return { status, disabled: false, reason: null };
  });
};
